export default {
  ONBOARDING_CUSTOMER_EXTRA_BANK_ACCOUNT_REPOSITORY: Symbol.for('ONBOARDING_CUSTOMER_EXTRA_BANK_ACCOUNT_REPOSITORY'),
  ONBOARDING_CREATE_CUSTOMER_EXTRA_BANK_ACCOUNT_COMMAND: Symbol.for('ONBOARDING_CREATE_CUSTOMER_EXTRA_BANK_ACCOUNT_COMMAND'),
};
